module.exports = __webpack_public_path__ + "static/media/Aditi.7a03ac2b.jpg";